import type { ReactNode } from 'react'

import { useAuth } from '../hooks/useAuth'
import cyranoLoading from '../assets/cyrano_loading.png'

import { LandingPage } from './LandingPage'

interface ProtectedRouteProps {
  children: ReactNode
}

// Reusable loading screen component
export const LoadingScreen = () => (
  <div className="flex justify-center items-center min-h-screen bg-gradient-custom">
    <div className="text-center space-y-4">
      <div className="mb-4">
        <img
          src={cyranoLoading}
          alt="Cyrano reading"
          className="h-34 w-auto mx-auto"
        />
      </div>
      <p className="text-lg text-white">Loading...</p>
    </div>
  </div>
)

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth()

  // Show loading while checking auth state
  if (loading) {
    return <LoadingScreen />
  }

  // Show landing page for unauthenticated users
  if (!user) {
    return <LandingPage />
  }

  return <>{children}</>
}
